import { INCREMENT, DECREMENT } from '../../constants/ReduxConstants';

export const increaseCounter = () => ({
  type: INCREMENT,
});

export const decreaseCounter = () => ({
  type: DECREMENT,
});
